import { render, staticRenderFns } from "./QuestionPractise.vue?vue&type=template&id=94e8b56c&scoped=true&"
import script from "./QuestionPractise.vue?vue&type=script&lang=ts&"
export * from "./QuestionPractise.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e8b56c",
  null
  
)

export default component.exports